import { useActuatorManualOperation } from '@/composables/useActuatorManualOperation';
import deviceInfo from "./components/deviceInfo";
import deviceStateMqtt from "./components/deviceStateMqtt";
import deviceStateAEP from "./components/deviceStateAEP";
import { reactive, toRefs, unref, ref, onMounted, computed } from "vue";
import { weChatrequest } from '@/utils/request';
import dateSelect from "@/components/dateSelect.vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { actuatorInvoke, addAudit, runtimeById, fetchActData, operationRecord, actuatorRuntimeExport } from "@/api/deviceManage";
import { techLoadingSvg } from '@/components/TechLoading/index.vue';
import NewEcharts from '@/components/Echart/NewEcharts';
import { Document, Refresh } from '@element-plus/icons-vue';
import { download } from "@/utils/index";
import { ElMessage } from 'element-plus';
export default {
  components: {
    deviceInfo,
    deviceStateMqtt,
    deviceStateAEP,
    dateSelect,
    NewEcharts,
    Document,
    Refresh
  },
  setup() {
    const route = useRoute();
    const manualOperation = useActuatorManualOperation();
    const router = useRouter();
    const deviceInfo = ref();
    const store = useStore();
    const userInfo = store.state.common.userInfo;
    const isControl = ref(false);
    const permissions = store.state.common.permissions;
    isControl.value = permissions.includes('device:page:control') ? true : false; //是否有设备控制的权限
    const isHasDetail = ref(false);
    isHasDetail.value = permissions.includes('device:page:detail') ? true : false; //是否有详细数据的权限
    const isactOp = ref(false);
    isactOp.value = userInfo.actOp == 1 ? true : false; //是否有执行器操作权限
    const isExport = ref(false);
    isExport.value = permissions.includes('device:page:exportDetail') ? true : false; //是否有运行数据的导出权限
    //格式化日期
    const dataFormat = val => {
      let year = val.getFullYear();
      let month = val.getMonth() + 1 < 10 ? "0" + (val.getMonth() + 1) : val.getMonth() + 1;
      let d = val.getDate() < 10 ? "0" + val.getDate() : val.getDate();
      let dayValue = year + '-' + month + '-' + d + " 00:00:00";
      return dayValue;
    };
    const imgUrl = ref([]);
    let deviceDetail = ref({
      actNum: "",
      airManufacturer: "",
      airMotor: "",
      areaId: "",
      branch: "",
      combPressureScm: "",
      combPressureSn: "",
      combPressureSr: "",
      cylinderEndTime: "",
      cylinderNum: "",
      latitude: "",
      location: "",
      longitude: "",
      motherBorderModel: "",
      motherBorderVersion: "",
      pipelinePressureScm: "",
      pipelinePressureSn: "",
      pipelinePressureSr: "",
      pressureScm: "",
      pressureSn: "",
      pressureSr: "",
      simNum: "",
      simOpenTime: "",
      valueInstallTime: "",
      valueModel: "",
      valueType: "",
      valveManufacturer: "",
      valveName: "",
      valveCode: "",
      imgUrl: []
    });
    let deviceStateData = ref({
      batLevel: '-',
      batTime: '-',
      bottleNumber: '-',
      bottlePressure: '-',
      humidity: '-',
      protectPressure: '-',
      supplyPressure: '-',
      temp: '-',
      valuePos: null,
      valueOpenPos: '-',
      actStatus: "",
      //'执行器状态;0-离线;1-在线'，
      actStatusTime: "",
      //'执行器上下线时间
      actAlarm: "",
      //'执行器告警状态原始值;0-正常;其它-告警;'
      actAlarmTime: "",
      //'执行器告警改变时间'
      actFwVersion: "",
      //执行器固件版本号
      actFwUpdateTime: "" //'执行器固件升级完成时间'
    });
    // 操作记录数据
    let operationRecords = ref([]);

    // 阀门状态是否异常：MQTT(actType==1) valuePos==2 为异常；AEP(actType==2) valuePos==5或6 为异常
    const isValveAbnormal = computed(() => {
      const actType = deviceDetail.value.actType;
      const valuePos = deviceStateData.value.valuePos;
      if (actType == 1) return valuePos == 2;
      if (actType == 2) return valuePos == 5 || valuePos == 6;
      return false;
    });

    // 获取时间轴类型
    const getTimelineType = status => {
      switch (status) {
        case '成功':
          return 'success';
        case '失败':
          return 'danger';
        case '进行中':
          return 'warning';
        default:
          return 'primary';
      }
    };

    // 获取标签类型
    const getTagType = status => {
      switch (status) {
        case '成功':
          return 'success';
        case '失败':
          return 'danger';
        case '进行中':
          return 'warning';
        default:
          return 'info';
      }
    };

    // 获取操作类型标签颜色
    const getOperationTagType = operateType => {
      switch (operateType) {
        case '开阀':
          return 'success';
        case '关阀':
          return 'info';
        default:
          return 'primary';
      }
    };

    // 获取状态标签类型
    const getStatusTagType = status => {
      switch (status) {
        case '成功':
          return 'success';
        case '失败':
          return 'danger';
        case '进行中':
          return 'warning';
        default:
          return 'info';
      }
    };
    const getResultClass = result => {
      switch (result) {
        case '成功':
          return 'success';
        case '失败':
          return 'fail';
        case '进行中':
          return 'processing';
        default:
          return 'unknown';
      }
    };
    const getOpoerRate = () => {
      state.refreshing = true;
      operationRecord(route.query.actId).then(res => {
        if (res.code == 0 && res.data) {
          operationRecords.value = res.data;
        }
      }).finally(() => {
        state.refreshing = false;
      });
    };
    const getNewData = () => {
      // 操作记录
      getOpoerRate();
      // 详细数据
      weChatrequest({
        url: `/api/v1/actuator/${route.query.actId}`,
        method: "get"
      }).then(res => {
        if (res.code == 0) {
          deviceDetail.value = res.data;
          if (deviceDetail.value.imgUrl) {
            imgUrl.value = res.data.imgUrl ? res.data.imgUrl.split(",") : [];
            const prefix = `${window.g.imgUrlPrex}`;
            imgUrl.value = imgUrl.value.map(item => prefix + item);
            console.log(imgUrl.value);
          } else {
            imgUrl.value = [];
          }
          console.log(imgUrl.value, 'imgUrl.value---');
        }
      });
      // 实时数据
      runtimeById(route.query.actId).then(res => {
        if (res.code == 0 && res.data) {
          deviceStateData.value = res.data;
          console.log(deviceStateData.value.valuePos, 'deviceStateData.valuePos');
        }
      });
    };

    // 带动画的刷新方法
    const handleRefresh = () => {
      state.isRefreshing = true;
      getNewData();
      // 动画结束后重置状态
      setTimeout(() => {
        state.isRefreshing = false;
      }, 1000);
    };
    const getActData = async () => {
      if (manualOperation.busy.value) return;
      state.actLoading = true;
      try {
        const result = await manualOperation.run(() => fetchActData({
          id: route.query.actId
        }), {
          operation: '召测'
        });
        if (result?.status === 'SUCCESS') getNewData();
      } finally {
        state.actLoading = false;
      }
    };
    onMounted(() => {
      // 非管理员默认显示第二个tab
      // if(!isHasDetail.value){
      //   state.activeName='two'
      // }else{
      //   state.activeName='first'
      // }
      getNewData();
    });
    const state = reactive({
      originDate: [],
      applyForm: {
        opStartTime: '',
        opEndTime: '',
        applyReason: ''
      },
      applyRules: {
        originDate: [{
          required: true,
          message: '请选择执行时间',
          trigger: 'blur'
        }],
        applyReason: [{
          required: true,
          message: '请输入申请事由',
          trigger: 'blur'
        }]
      },
      form: {
        id: route.query.id,
        name: route.query.name,
        //设备名称
        sn: route.query.sn,
        //设备序列号
        activeStatus: route.query.active,
        //设备状态-已激活1、未激活0
        activeTime: null,
        //激活时间
        isForbidden: null,
        //禁用0、启用1
        deviceVersion: null,
        //固件版本
        systemVersion: null,
        //系统版本
        platformVersion: null,
        //平台版本
        productId: route.query.productId,
        isOnline: route.query.isOnline,
        nodeType: null,
        areaName: null,
        orgName: null,
        productKey: null,
        productName: route.query.productName,
        product: {
          id: null,
          name: null,
          nodeType: null,
          nodeTypeTag: null,
          productKey: null
        }
      },
      angleValue: 90,
      valuePos: null,
      valveSwitch: 0,
      applyLoading: false,
      dialogVisible: false,
      activeName: "two",
      operation: route.query.operation,
      defaultTimeSet: dataFormat(new Date()),
      fixTime: dataFormat(new Date()),
      showOne: false,
      chartLoading: false,
      actLoading: false,
      refreshing: false,
      isRefreshing: false,
      //图表查询条件
      queryParamsOne: {
        startTime: "",
        endTime: "",
        dateType: "day"
      },
      chartData: []
    });
    // 时间改变
    const timeChange = val => {
      if (val?.length) {
        state.applyForm.opStartTime = val[0];
        state.applyForm.opEndTime = val[1];
      } else {
        state.applyForm.opStartTime = '';
        state.applyForm.opEndTime = '';
      }
    };
    const clickOperate = function (type) {
      state.valuePos = type;
      // if (deviceDetail.value.actType == 1) {
      //   state.angleValue = type
      // }
      if (!isactOp.value) {
        // 没有执行器操作权限，提工单，走申请
        state.dialogVisible = true;
        return;
      }
      if (state.angleValue == null) {
        ElMessage.closeAll();
        ElMessage.warning("请输入控制角度");
        return;
      }
      let openType = "";
      if (type == 0 || type == 2) {
        openType = "关阀";
      }
      if (type == 1) {
        openType = "开阀";
      }
      //  let params1 = {
      //   valuePos: type,
      //   valueOpenPos: state.angleValue,
      //   id: route.query.actId,
      // }
      // console.log(params1,'params1----')
      // return
      // 首先弹出确认框确认是否要进行开关阀操作
      ElMessageBox.confirm("确定要" + openType + "吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 用户确认后，再调用 canInvoke 接口检查是否可以执行
        weChatrequest({
          url: `/api/v1/actuator/canInvoke/${route.query.actId}`,
          method: "get"
        }).then(canInvokeRes => {
          if (canInvokeRes.code == 0 && canInvokeRes.data.canInvoke) {
            // 返回 true，直接执行阀门操作
            executeActuatorInvoke(type, openType);
          } else {
            // 返回 false，弹出二次确认提示框
            ElMessageBox.confirm(canInvokeRes.data.message || '确定要继续执行阀门操作吗？', "提示", {
              confirmButtonText: "继续" + openType,
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              executeActuatorInvoke(type, openType);
            }).catch(() => {
              // 用户取消操作
            });
          }
        }).catch(() => {
          // canInvoke 接口调用失败，直接执行阀门操作
          executeActuatorInvoke(type, openType);
        });
      }).catch(() => {
        // 用户取消操作
      });
    };

    // 执行阀门操作
    const executeActuatorInvoke = function (type, openType) {
      if (manualOperation.busy.value) return;
      let params = {
        valuePos: type,
        valueOpenPos: state.angleValue,
        id: route.query.actId
      };
      manualOperation.run(() => actuatorInvoke(params), {
        operation: type == 1 ? '开阀' : '关阀'
      }).then(result => {
        if (result?.finished) getNewData();
      });
    };
    let formatWellType = wellType => {
      if (wellType == 1 || wellType == 2) {
        return '井盖监控器';
      } else if (wellType == 11 || wellType == 12) {
        return '智能电子锁井盖';
      } else if (wellType == 122) {
        return '4G智能电子锁井盖';
      }
    };
    const applyFormRef = ref(null);
    const methods = reactive({
      closeApply() {
        state.dialogVisible = false;
      },
      submitApply() {
        const formEl = unref(applyFormRef);
        formEl.validate(valid => {
          if (valid) {
            let params = {
              ...state.applyForm
            };
            params.actNum = deviceDetail.value.actNum;
            params.valuePos = state.valuePos;
            params.valueOpenPos = state.angleValue;
            params.actType = deviceDetail.value.actType;
            delete params.originDate;
            state.applyLoading = true;
            addAudit(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("新增成功");
                state.dialogVisible = false;
                getNewData();
              } else {
                ElMessage.error(response.msg);
              }
              state.applyLoading = false;
            }).catch(() => {
              state.applyLoading = false;
            });
          }
        });
      },
      goList() {
        router.go(-1);
      },
      formatOnlineState(communicationState) {
        if (communicationState == 0) {
          return "报警";
        } else if (communicationState == 1) {
          return "掉线";
        } else if (communicationState == 2) {
          return "休眠";
        } else if (communicationState == 3) {
          return "在线";
        }
      },
      handleClick(tab, event) {
        console.log(tab.paneName);
      },
      // 加载历史数据
      loadHistoryData() {
        state.chartLoading = true;
        weChatrequest({
          url: `${process.env.VUE_APP_IOT_API}/bdmanholeCover/histroy`,
          method: "post",
          data: {
            manholeCode: route.query.manholeCode,
            startTime: state.queryParamsOne.startTime,
            //"2023-07-26 00:00:00",
            endTime: state.queryParamsOne.endTime,
            //"2023-07-26 19:00:00",
            dateType: state.queryParamsOne.dateType
          }
        }).then(res => {
          if (res.code == 1000) {
            let colorList = ['#00C1FF', '#F7B12A', '#EB5757'];
            state.chartData = res.data.map((item, index) => {
              item.color = colorList[index];
              return item;
            });
          }
          state.chartLoading = false;
          state.showOne = true;
        });
      },
      disabledDateOne(time) {
        if (time.getTime() > new Date().getTime()) {
          return time.getTime() >= new Date().getTime();
        }
      },
      //按钮点击事件
      radioChange(val) {
        state.chartData = [];
        state.queryParamsOne.dateType = val;
      },
      //图表时间点击事件
      chartSelectChange(val) {
        state.chartData = [];
        if (state.queryParamsOne.dateType == 'day') {
          state.queryParamsOne.startTime = val + " 00:00:00";
          state.queryParamsOne.endTime = val + " 00:00:00";
        } else {
          state.queryParamsOne.startTime = val[0] + " 00:00:00";
          state.queryParamsOne.endTime = val[1] + " 00:00:00";
        }
        // methods.loadHistoryData()
      },
      //导出运行数据
      handleExport() {
        ElMessageBox.close();
        ElMessageBox.confirm('是否确认导出当前设备运行数据?', "导出", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          let params = {
            id: route.query.actId
          };
          actuatorRuntimeExport(params).then(res => {
            if (res.status === 200) {
              let fileName = decodeURI(res.headers["content-disposition"].split("utf-8''")[1]);
              download(res.data, fileName);
              ElMessage.success("导出成功");
            }
          }).catch(() => {
            ElMessage.error("导出失败");
          });
        }).catch(() => {
          // 取消导出
        });
      }
    });
    return {
      manualBusy: manualOperation.busy,
      manualProgressText: manualOperation.progressText,
      techLoadingSvg,
      ...toRefs(state),
      ...toRefs(methods),
      deviceInfo,
      formatWellType,
      getActData,
      store,
      imgUrl,
      route,
      deviceDetail,
      deviceStateData,
      operationRecords,
      isValveAbnormal,
      getTimelineType,
      getTagType,
      getOperationTagType,
      getStatusTagType,
      getResultClass,
      timeChange,
      isHasDetail,
      isControl,
      isactOp,
      isExport,
      router,
      applyFormRef,
      clickOperate,
      getNewData,
      getOpoerRate,
      handleRefresh
    };
  }
};